// extracted by mini-css-extract-plugin
module.exports = {"item":"Icons_item__aIaWQ","fill":"Icons_fill__qkcLl","button":"Icons_button__nzbu8","link":"Icons_link__TEvVr","icon":"Icons_icon__wXY4G","text":"Icons_text__x0GKl"};